import { Undo, UndoService } from 'roosterjs-editor-core';

export default function createUndo(preserveSnapshots?: boolean): UndoService {
    return new Undo(preserveSnapshots);
}
